var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMoneyModalBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 160,
    viewBox: "0 0 228 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 3259",
    filter: "url(#filter0_f_5205_19462)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -8.00515,
    cy: 207.835,
    rx: 127,
    ry: 70,
    transform: "rotate(29.7816 -8.00515 207.835)",
    fill: "url(#paint0_linear_5205_19462)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5205_19462",
    x: -243.616,
    y: 0.257812,
    width: 471.222,
    height: 415.156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_5205_19462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5205_19462",
    x1: -86.0194,
    y1: 116.335,
    x2: 147.823,
    y2: 147.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680584,
    stopColor: "#C850C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4158D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMoneyModalBackground);
export default __webpack_public_path__ + "static/media/addMoneyModalBackground.a988f6cdd660bcd68e203af34441a1ed.svg";
export { ForwardRef as ReactComponent };